module.exports = __webpack_public_path__ + "img/avatar.81201591.svg";